import {
  ResponseCreatePersonalFood,
  ResponseGetPersonalFood,
  ResponseGetRatioArray,
  ResponsePersonalPackages,
} from './../../core/model/api-response/persoanl-response-model';
import { packageSuggester } from './../../core/model/api-response/plans-response-model';
import {
  ResponseAddActivityLog,
  updateExercise,
} from './../../core/model/object/exercise-model';
import {
  ExerciseSearchResponce,
  ResponseDayExerciseLogs,
} from './../../core/model/api-response/plans-response-model';
import {
  CategoryListResponce,
  DeleteVoteFaqResponce,
  FaqAnswerResponce,
  FaqSubCategoryListResponce,
  messageBadge,
  messageInboxResponce,
  SearchFaqResponse,
  SendVoteFaqResponce,
  SuppotTicketsResponce,
  UpdateMessageResponce,
} from './../../core/model/api-response/support-responce.model';
import { FoodLogModel } from './../../core/model/object/foodlog-model';
import { BookmarkModel } from './../../core/model/object/recipe-model';
import { FastingModel, TypeModel } from './../../core/model/object/diet-model';
import { PredefinedDietsResponseModel } from './../../core/model/generate-response-model';
import {
  BlogGetUser2ResponseModel,
  BlogActivityResponseModel,
  GetFollowRequestsResponseModel,
} from './../../core/model/api-response/blog-response-model';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { Waterlog } from 'src/app/core/model/api-response/water-log-response-model';
import {
  DietSearchMealModel,
  DietDayModel,
  DietModel,
  DietSearchedFoodModel,
} from 'src/app/core/model/object/diet-model';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import {
  BlogListModel,
  BlogTagModel,
  BlogCommentsArrayModel,
  BlogReplyModel,
  BlogCommentModel,
  BlogPostModel,
} from 'src/app/core/model/object/blog-model';
import {
  PlanPriceModel,
  PlanSubscriptionModel,
  AutomaticDiscountPriceResponseModel,
} from 'src/app/core/model/object/shop-model';
import { AddOrEditFoodResponseFoodModel } from 'src/app/core/model/api-response/diet-response-model';
import { PriceResponseModel } from 'src/app/core/model/api-response/shop-response-model';
import { ReferralUser } from 'src/app/core/model/api-response/profile-response-model';
import {
  RecipeCategoryModel,
  RecipeDetailModel,
} from 'src/app/core/model/object/recipe-model';
import {
  RecipeCategoryResponseModel,
  RecipeDetailResponseModel,
} from 'src/app/core/model/api-response/recipe-response-model';
import { FoodLogChartModel } from 'src/app/core/model/api-response/food-log-response-model';
import { DietsListCategory } from 'src/app/core/model/api-response/plans-response-model';
import {
  CookingStoryCategories,
  cookingStoryKitchenSearchResponce,
  cookingStoryMoreCategorie,
  CookingStoryPageResponce,
  createKitchenResponce,
  createshoppingListResponce,
  getHomeMembers,
  groceryCategoryRespoce,
  KitchenHomeItemResponce,
  kitchenSuggestion,
  shoppingListHomeItemResponce,
} from 'src/app/core/model/api-response/cooking-story-model';

export class GenericResponse {
  constructor(private success: boolean, private data?: GenericResponseData) {}

  isSuccess() {
    return this.success;
  }

  getData() {
    return this.data;
  }
}
export class BaseResponse {
  constructor(
    public statusCode: number,
    public message_id: number,
    public success: boolean
  ) {}
}
interface GenericResponseDataParams {
  BaseResponse?: BaseResponse;
  message?: string;
  type?: string;
  weightlogs?: Weightlog[];
  waterlogs?: Waterlog[];
  meals?: DietSearchMealModel[];
  searchedFoods?: DietSearchedFoodModel[];
  foods?: FoodModel[];
  dietDay?: DietDayModel;
  days?: number;
  dietId?: string;
  dietCalorie?: number;
  diets?: DietModel[];
  weightLog?: Weightlog;
  blogList?: BlogListModel;
  blogTagArray?: BlogTagModel[];
  blogCommentsArrayModel?: BlogCommentsArrayModel;
  blogReply?: BlogReplyModel;
  blogComment?: BlogCommentModel;
  planPrices?: PlanPriceModel[];
  planPricesResponse?: PriceResponseModel;
  automaticDiscountPrices?: AutomaticDiscountPriceResponseModel;
  planSubscription?: PlanSubscriptionModel;
  startDay?: number;
  lockPlan?: boolean;
  addOrEditFoodResponse?: AddOrEditFoodResponseFoodModel;
  blogUserId?: string;
  blogUser?: BlogUserModel;
  blogGetUserModel?: BlogGetUser2ResponseModel;
  blogUsers?: BlogUserModel[];
  blogActivityResponse?: BlogActivityResponseModel;
  blogPost?: BlogPostModel;
  blogFollowRequests?: GetFollowRequestsResponseModel;
  predefinedDietsResponse?: PredefinedDietsResponseModel;
  referralUsers?: ReferralUser[];
  dietType?: TypeModel;
  recipeCategories?: RecipeCategoryModel[];
  recipeCategoryResponse?: RecipeCategoryResponseModel;
  recipeDetail?: RecipeDetailModel;
  bookmarks?: BookmarkModel[];
  foodLogs?: FoodLogModel[];
  foodLogChart?: FoodLogChartModel[];
  reward?: number;
  dietRemainingDays?: number;
  supportCategories?: CategoryListResponce;
  faqSubCategories?: FaqSubCategoryListResponce;
  faqSearchResponce?: SearchFaqResponse;
  faqAnswerResponce?: FaqAnswerResponce;
  sendMessageResponce?: SuppotTicketsResponce;
  messageBadgeResponce?: messageBadge;
  messageInboxResponce?: messageInboxResponce;
  updateMessageResponce?: UpdateMessageResponce;
  voteFaqResponce?: SendVoteFaqResponce;
  deleteVoteFaqResponce?: DeleteVoteFaqResponce;
  dietsListCategories?: DietsListCategory[];
  fasting?: FastingModel;
  packageSuggest?: packageSuggester;
  personalFood?: ResponseCreatePersonalFood;
  getPersonalFood?: ResponseGetPersonalFood;
  foodUnitId?: ResponseGetRatioArray[];
  getPersonalPackage?: ResponsePersonalPackages;
  exerciseSearchResponce?: ExerciseSearchResponce;
  responseDayLogs?: ResponseDayExerciseLogs[];
  addActivityLog?: ResponseAddActivityLog;
  updateExercise?: updateExercise;
  cookingStory?: CookingStoryCategories;
  cookingStoryPage?: CookingStoryPageResponce;
  cookingStoryRes?: RecipeDetailResponseModel;
  cookingStoryMorePost?: cookingStoryMoreCategorie;
  cookingStoryKitchenResponce?: cookingStoryKitchenSearchResponce;
  KitchenHomeItemResponce?: KitchenHomeItemResponce;
  groceryCategoryRespoce?: groceryCategoryRespoce;
  createKitchenResponce?: createKitchenResponce;
  shoppingListHomeItemResponce?: shoppingListHomeItemResponce;
  createShoppingListResponce?: createshoppingListResponce;
  getHomeMembers?: getHomeMembers;
  kitchenSuggestion?: kitchenSuggestion;
}

export class GenericResponseData {
  constructor(private params: GenericResponseDataParams) {}

  getMessage() {
    return this.params.message;
  }

  getType() {
    return this.params.type;
  }

  getWeightlogs() {
    return this.params.weightlogs;
  }

  getWaterlogs() {
    return this.params.waterlogs;
  }

  getMeals() {
    return this.params.meals;
  }

  getSearchedFoods() {
    return this.params.searchedFoods;
  }

  getFoods() {
    return this.params.foods;
  }

  getDietDay() {
    return this.params.dietDay;
  }

  getDaysCount() {
    return this.params.days;
  }

  getDietId() {
    return this.params.dietId;
  }

  getDietCalorie() {
    return this.params.dietCalorie;
  }

  getDiets() {
    return this.params.diets;
  }

  getWeightLog() {
    return this.params.weightLog;
  }

  getBlogList() {
    return this.params.blogList;
  }

  getBlogTagArray() {
    return this.params.blogTagArray;
  }

  getBlogCommentsArrayModel() {
    return this.params.blogCommentsArrayModel;
  }

  getBlogReply() {
    return this.params.blogReply;
  }

  getBlogComment() {
    return this.params.blogComment;
  }

  getPlanPrices() {
    return this.params.planPrices;
  }

  getPlanSubscription() {
    return this.params.planSubscription;
  }

  getStartDay() {
    return this.params.startDay;
  }

  getLockPlan() {
    return this.params.lockPlan;
  }

  getAddOrEditFoodResponse() {
    return this.params.addOrEditFoodResponse;
  }

  getBlogUserId() {
    return this.params.blogUserId;
  }

  getBlogUser() {
    return this.params.blogUser;
  }

  GetBlogUserResponse() {
    return this.params.blogGetUserModel;
  }

  getBlogUsers() {
    return this.params.blogUsers;
  }

  getBlogActivityList() {
    return this.params.blogActivityResponse;
  }

  getBlogPost() {
    return this.params.blogPost;
  }

  getBlogFollowRequests() {
    return this.params.blogFollowRequests;
  }

  getPlanPricesResponse() {
    return this.params.planPricesResponse;
  }

  getAutomaticDiscountPrices() {
    return this.params.automaticDiscountPrices;
  }

  getPredefinedDietsResponse() {
    return this.params.predefinedDietsResponse;
  }

  getReferralUsers() {
    return this.params.referralUsers;
  }

  getDietType() {
    return this.params.dietType;
  }

  getRecipeCategories() {
    return this.params.recipeCategories;
  }

  getRecipeCategoryResponse() {
    return this.params.recipeCategoryResponse;
  }

  getRecipeDetail() {
    return this.params.recipeDetail;
  }

  getBookmarks() {
    return this.params.bookmarks;
  }

  getFoodLogs() {
    return this.params.foodLogs;
  }

  getFoodLogChart() {
    return this.params.foodLogChart;
  }

  getReward() {
    return this.params.reward;
  }

  getDietRemainingDays() {
    return this.params.dietRemainingDays;
  }

  getSupportCategories() {
    return this.params.supportCategories;
  }

  getFaqSubCategories() {
    return this.params.faqSubCategories;
  }

  getFaqSearchResponce() {
    return this.params.faqSearchResponce;
  }

  getFaqAnswerResponce() {
    return this.params.faqAnswerResponce;
  }

  getMessageResponce() {
    return this.params.sendMessageResponce;
  }

  getMessageBadgeResponce() {
    return this.params.messageBadgeResponce;
  }

  getMessageInboxResponce() {
    return this.params.messageInboxResponce;
  }

  getUpdateMessageResponce() {
    return this.params.updateMessageResponce;
  }

  getVoteFaqResponce() {
    return this.params.voteFaqResponce;
  }

  getDeleteVoteFaqResponce() {
    return this.params.deleteVoteFaqResponce;
  }

  getDietsListCategories() {
    return this.params.dietsListCategories;
  }

  getFasting() {
    return this.params.fasting;
  }
  getSuggetions() {
    return this.params.packageSuggest;
  }
  getPersonalFood() {
    return this.params.personalFood;
  }
  getRPersonaFood() {
    return this.params.getPersonalFood;
  }
  getFoodUnitId() {
    return this.params.foodUnitId;
  }
  getPersonalPackage() {
    return this.params.getPersonalPackage;
  }
  getExerciseSearch() {
    return this.params.exerciseSearchResponce;
  }
  getResponseDayLogs() {
    return this.params.responseDayLogs;
  }
  getResponseAddActivityLog() {
    return this.params.addActivityLog;
  }
  getUpdateExercise() {
    return this.params.updateExercise;
  }
  getCookingStoryCategories() {
    return this.params.cookingStory;
  }
  getCookingStoryPage() {
    return this.params.cookingStoryPage;
  }
  getCookingStoryRecipe() {
    return this.params.cookingStoryRes;
  }
  getCookingStoryMorePost() {
    return this.params.cookingStoryMorePost;
  }
  getCookingStoryKitchenResponce() {
    return this.params.cookingStoryKitchenResponce;
  }
  getKitchenHomeItemResponce() {
    return this.params.KitchenHomeItemResponce;
  }
  getGroceryCategoryRespoce() {
    return this.params.groceryCategoryRespoce;
  }
  getCreateKitchenResponce() {
    return this.params.createKitchenResponce;
  }
  getShoppingListHomeItemResponce() {
    return this.params.shoppingListHomeItemResponce;
  }
  getCreateShoppingListRecpoce() {
    return this.params.createShoppingListResponce;
  }
  getHomeMembers() {
    return this.params.getHomeMembers;
  }
  getkitchenSuggestion() {
    return this.params.kitchenSuggestion;
  }
}
